import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

function afterPaint(cb) {
  if (typeof requestIdleCallback === 'function') {
    requestIdleCallback(cb, { timeout: 2000 });
  } else {
    requestAnimationFrame(() => setTimeout(cb, 0));
  }
}

afterPaint(async () => {
  const { initAnalytics } = await import('./lib/metrics.js');
  const { initSentry } = await import('./lib/sentry.js');
  initAnalytics();
  initSentry();
});
